type CurrencyFormatOptions = {
  currency: string
  decimals?: number
  locale?: string
}

const createIntlCurrencyFormatter = (options: CurrencyFormatOptions) => {
  const { locale = 'en-US', currency, decimals } = options

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toUpperCase(),
    ...(decimals !== undefined
      ? {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }
      : { minimumFractionDigits: 2, maximumFractionDigits: 6 }),
  })
}

// Use this for one-off formatting
export const formatCurrency = (amount: number, options: CurrencyFormatOptions): string => {
  return createIntlCurrencyFormatter(options).format(amount)
}

// Use this when formatting multiple values with the same options
export const createCurrencyFormatter = (options: CurrencyFormatOptions) => {
  const formatter = createIntlCurrencyFormatter(options)
  const format = (amount: number) => formatter.format(amount)
  return format
}

// Legacy function name, to be removed in the future
export const to_currency = (amount: number, currency: string): string => {
  return formatCurrency(amount, { currency })
}
